// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3UF9e","clinicsSelect":"TableHeading_clinicsSelect__3eiPN"};